import { TonConnect } from '@/features/tonConnect'

export const TonConnectPageWiew = () => {
  return <TonConnect />
}
